import type { AdcampaignPlaybackReportTypeForInput } from '@shared/api/graphql/generated';

import type { ReportRecipientType } from './ReportRecipientsSelect/types';

export const AUDIO_REPORT_SCOPE = {
  COMMON: 'common',
  ADDRESSES: 'addresses',
  PROMOS: 'promos',
} as const;

export type AudioReportScopeType = (typeof AUDIO_REPORT_SCOPE)[keyof typeof AUDIO_REPORT_SCOPE];

export type ReportAddressTagType = {
  id: string;
  title: string;
};

export type ReportAddressType = {
  id: string;
  address: string;
  comment?: string;
  tags: ReportAddressTagType[];
};

export interface RequestAdCampaignsReportModalProps {
  refetchReports: () => void;
  adcampaignReportType: AdcampaignPlaybackReportTypeForInput;
}

export type DateRangeChangeHandler = (startDate: Date | null, endDate: Date | null) => void;

type BaseAdCampaignsReportModalProps = {
  close: () => void;
  closeButtonText: string;
  endDate: Date | null;
  isMobile: boolean;
  isRequestDisabled: boolean;
  loading: boolean;
  modalTitle: string;
  onDateRangeChange: DateRangeChangeHandler;
  onRequestSubmit: () => void;
  requestButtonText: string;
  startDate: Date | null;
};

export type DefaultAdCampaignsReportModalProps = BaseAdCampaignsReportModalProps;

export type AudioAdCampaignsReportModalProps = BaseAdCampaignsReportModalProps & {
  externalRecipientEmails: string[];
  isExternalRecipientsInputVisible: boolean;
  isReportAddressesLoading: boolean;
  onExternalRecipientEmailsChange: (emails: string[]) => void;
  onReportScopeChange: (scope: AudioReportScopeType) => void;
  onSelectedAddressIdsChange: (addressIds: string[]) => void;
  onSelectedRecipientIdsChange: (recipientIds: string[]) => void;
  onShowExternalRecipientsInput: () => void;
  recipients: ReportRecipientType[];
  reportAddresses: ReportAddressType[];
  reportAddressTags: ReportAddressTagType[];
  reportScope: AudioReportScopeType;
  selectedAddressIds: string[];
  selectedRecipientIds: string[];
};
